export var ServerZone;

(function (ServerZone) {
  ServerZone["US"] = "US";
  ServerZone["EU"] = "EU";
  ServerZone["STAGING"] = "STAGING";
})(ServerZone || (ServerZone = {}));